/* design system */

const FALLBACK_FONT =
  ', Pretendard, "Noto Sans JP", -apple-system, BlinkMacSystemFont, system-ui, Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR", "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", sans-serif';
export const FONT_GIANT_400 = `normal 400 48px / 57px "Pretendard Variable" ${FALLBACK_FONT}`;
export const FONT_HUGE_400 = `normal 400 36px / 40px "Pretendard Variable" ${FALLBACK_FONT}`;
export const FONT_BIG_400 = `normal 400 24px / 31px "Pretendard Variable" ${FALLBACK_FONT}`;
export const FONT_LARGE_400 = `normal 400 18px / 27px "Pretendard Variable" ${FALLBACK_FONT}`;
export const FONT_LARGE_600 = `normal 600 18px / 27px "Pretendard Variable" ${FALLBACK_FONT}`;
export const FONT_MEDIUM_400 = `normal 400 16px / 23px "Pretendard Variable" ${FALLBACK_FONT}`;
export const FONT_SMALL_400 = `normal 400 14px / 20px "Pretendard Variable" ${FALLBACK_FONT}`;
export const FONT_TINY_400 = `normal 400 12px / 16px "Pretendard Variable" ${FALLBACK_FONT}`;

// micro, mini, nano, huge, giant, mega
